import React from 'react'
import PropTypes from 'prop-types'
import { Content } from './components/common'

const BOTTrailerTireLines = ({ trailerTireLineDetails, useFlex, TireLines }) =>
  <Content useFlex={ useFlex }>
    <TireLines tireLines={ trailerTireLineDetails } />
  </Content>

export default BOTTrailerTireLines

BOTTrailerTireLines.propTypes = {
  TireLines: PropTypes.func,
  trailerTireLineDetails: PropTypes.shape({}),
  useFlex: PropTypes.bool
}
